/**
 * Testing Methodology scoring accordion.
 *
 * The same seven cards are rendered twice: a stacked list for mobile and a mosaic for desktop.
 * Only one card may stay open per two-card desktop column, which is what keeps the mosaic height
 * stable while a card expands.
 */

const cardsRoot = document.querySelector('#testing-methodology-page .cards');

if (cardsRoot) {
  const openDesktopCard = card => {
    const column = card.closest('.cards__desc-tw');

    if (column) {
      column.querySelectorAll('.cards__card.active').forEach(sibling => {
        if (sibling !== card) {
          sibling.classList.remove('active');
        }
      });
    }

    card.classList.add('active');
  };

  cardsRoot.addEventListener('click', event => {
    const card = event.target.closest('.cards__card');

    if (!card) {
      return;
    }

    const toggle = event.target.closest('.cards__card-header-btns');

    if (card.closest('.cards__mobile')) {
      if (toggle) {
        card.classList.toggle('active');
      }

      return;
    }

    if (toggle) {
      openDesktopCard(card);
    } else if (event.target.matches('.cards__card-body > .fa-minus-circle')) {
      card.classList.remove('active');
    }
  });
}
